export default __webpack_public_path__ + "static/media/bee new-min.8ab65563.png";